export interface SettingsPage {
    key: string;
    title: string;
    roles: string[];
}

export const SETTINGS_PAGES: SettingsPage[] = [
    { key: 'account', title: 'Mon Compte', roles: ['Admin', 'Editor', 'Analyst', 'Employee'] },
    { key: 'organization', title: 'Mon Entreprise', roles: ['Admin', 'Editor', 'Analyst'] },
    { key: 'team', title: 'Mon Équipe', roles: ['Admin'] },
    { key: 'payment', title: 'Mes Infos de Paiement', roles: ['Admin'] },
    { key: 'invoices', title: 'Mes Factures', roles: ['Admin', 'Editor', 'Analyst'] },
];
